import React from 'react';
import ActiveUsersWidget from './ActiveUsersWidget';
import MfaAdminDashboard from './MfaAdminDashboard';
import { useAuth } from '../hooks/useAuth';
import '../styles/AdminDashboard.css';

const AdminDashboard = () => {
  const { user, hasPermission } = useAuth();

  // Only show to admin users
  if (!hasPermission('/admin-dashboard', 'View')) {
    return (
      <div className="admin-dashboard">
        <div className="access-denied">
          <h2>Access Denied</h2>
          <p>You don't have permission to view this dashboard.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-dashboard">
      <div className="dashboard-header">
        <h1>Administration Dashboard</h1>
        <p>Monitor system usage and user activity</p>
      </div>

      <div className="dashboard-content">
        <div className="dashboard-row">
          <div className="dashboard-col-full">
            <ActiveUsersWidget />
          </div>
        </div>
        
        {/* MFA Admin Dashboard */}
        <div className="dashboard-row">
          <div className="dashboard-col-full">
            <MfaAdminDashboard />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
